export const fileServiceMessages = {
  FALLBACK_ERROR: 'An error occurred',
  PREVIEW: {
    ERROR: 'Unable to open file preview',
    SHAPEFILE_ERROR: 'Could Not Open Shapefile Preview',
    UNSUPPORTED_FILE: 'Unsupported file type',
  },
  PERMISSIONS: {
    GET_USERS_ERROR: 'Unable to get users',
    GET_USER_ERROR: 'Unable to get user',
    GET_GROUPS_ERROR: 'Unable to get groups',
    GET_LAYERS_ERROR: 'Unable to get layers',
    GET_VERSION_HISTORY_ERROR: 'Unable to get version history',
    UPDATE_PERMISSIONS_SUCCESS: 'Permissions updated successfully',
    UPDATE_PERMISSIONS_ERROR: 'Unable to update permissions',
    GET_PERMISSIONS_ERROR: 'Unable to get permissions',
  },
};
